import { FileRefObjs, FileTypes } from '../types/Files/FileTypes';
export const getUpdateObjFromUpload = (type: FileTypes, url: string) => {
  let returnObj;
  switch (type) {
    case 'abnSig':
      returnObj = { signature1DataURI: url };
      break;
    case 'aobSig1':
      returnObj = { signature1DataURI: url };
      break;
    case 'aobSig2':
      returnObj = { signature2DataURI: url };
      break;
    case 'consentSig':
      returnObj = { signature1DataURI: url };
      break;
    case 'hipaaSig':
      returnObj = { signature1DataURI: url };
      break;
    case 'insuranceABNSig':
      returnObj = { signature1DataURI: url };
      break;
    case 'medicareABNSig':
      returnObj = { signature1DataURI: url };
      break;
    case 'patientSig':
      returnObj = { signature1DataURI: url };
      break;
    case 'witness1':
      returnObj = { signature1DataURI: url };
      break;
    case 'finalVideo':
      returnObj = { videoDownloadURI: url };
      break;
    case 'idFront':
      returnObj = { photoIdentificationFrontURI: url };
      break;
    case 'idBack':
      returnObj = { photoIdentificationBackURI: url };
      break;
    case 'healthInsuranceFront':
      returnObj = { healthInsuranceCardFrontURI: url };
      break;
    case 'healthInsuranceBack':
      returnObj = { healthInsuranceCardBackURI: url };
      break;
    case 'livingWill':
      returnObj = { livingWillURI: url };
      break;
    case 'medicareFront':
      returnObj = { medicareCardFrontURI: url };
      break;
    case 'medicareBack':
      returnObj = { medicareCardBackURI: url };
      break;
    case 'medicareFront2':
      returnObj = { medicareCardFrontURI2: url };
      break;
    case 'medicareBack2':
      returnObj = { medicareCardBackURI2: url };
      break;
    case 'POLST':
      returnObj = { POLSTURI: url };
      break;
    case 'portrait':
      returnObj = { portraitURI: url };
      break;
    case 'powerOfAttorney':
      returnObj = { powerOfAttorneyURI: url };
      break;
    case 'readerIdFront':
      returnObj = { readerIdentificationFrontURI: url };
      break;
    case 'witness2':
      returnObj = { signature2DataURI: url };
      break;
  }
  return returnObj as FileRefObjs;
};
